// Search filters carried over when leaving the trips search for another page,
// so the destination keeps the dates/party size the client already picked.
export const FORWARDED_SEARCH_PARAMS = ["from_date", "to_date", "guest_count"]
